import CommonTabContent from '../../../components/common-tab-content';
const CustomTabContent: React.FC = () => {
	return (
		<div className="max-w-2xl">
			<div className="mb-4">
				<select className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6">
					<option>Explain SQL Query</option>
					<option value="1">Highlight agent actions</option>
				</select>
			</div>
			<CommonTabContent />
		</div>
	);
};

export default CustomTabContent;
